import type { ITemplateData } from '.'
import type { ColDef } from 'ag-grid-community'

import TemplateKeyCellRenderer from '~/components/CellRenderers/TemplateKeyCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import sharedHeaderTemplate from '~/components/HeaderTemplate'
import { valueComparator } from '~/utils/comparators'
import { textColDef } from '~/utils/table'

const columns: ColDef<ITemplateData>[] = [
  {
    cellRenderer: TemplateKeyCellRenderer,
    comparator: valueComparator,
    field: 'title',
    headerComponentParams: {
      template: sharedHeaderTemplate({
        color: 'grey',
        headerSubtitle: 'Key',
        headerSubtitleClassname: 'capitalized',
        headerTitle: 'Title',
      }),
    },
    headerName: '',
    minWidth: 350,
  },
  textColDef(TextCellRenderer, {
    field: 'versionCount',
    headerName: 'Versions count',
    resizable: false,
    suppressHeaderMenuButton: true,
  }),
]

export default columns
